'use strict'

$(document).ready(function($){
  setTimeout(function(){
    if(window.innerWidth > 1024){
    $('div#cb-widget-currency').insertBefore('.logo-area__right__inner .header_wishlist').css('display','inline-block');
    } else{$('div#wishlisthero-product-page-button-container').insertBefore('.quantity-submit-row__submit.input-row .wishlist_share-icons').css('display','inline-block');
}
    }, 3000)
});

// if($(window).width() < 1024){
// $('li.navigation__item').click(function(){
// 	$(this).find('[aria-controls="NavigationTier2-1"] + .navigation__children-toggle').trigger('click');
// })
// }

